export enum EntityApiEnum {
    FIN_WALLET                      = '/wallet',
    FIN_TRADE                       = '/trade',
    FIN_TRADE_ACCOUNT_TRANSFER      = '/trade/account-transfer',
    FIN_INVESTMENT                  = '/investment',
    FIN_ISIN                        = '/isin',
    FIN_ISIN_VALUE                  = '/isin-value',
    FIN_ETIQUETTE                   = '/etiquette',
    SHARED_LOOKUP                   = '/shared/lookup',
    FIN_TRADE_ETIQUETTE_RECAP       = '/trade-etiquette/recap',
    FIN_WALLET_RECAP                = '/wallet/recap',
    FIN_WALLET_RECAP_PROGRESSION_LIQ    = '/wallet/recap-progression-liq',
    FIN_WALLET_RECAP_PROGRESSION_INV    = '/wallet/recap-progression-inv',
    FIN_INVESTMENT_RECAP            = '/investment/recap',
}
